import { render } from "./WavetoApp.vue?vue&type=template&id=52c74174&scoped=true"
import script from "./WavetoApp.vue?vue&type=script&lang=js"
export * from "./WavetoApp.vue?vue&type=script&lang=js"

import "./WavetoApp.vue?vue&type=style&index=0&id=52c74174&scoped=true&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c74174"]])

export default __exports__